import { Typography } from '@mui/material';
import { PropsWithChildren, useRef } from 'react';

import { CheckboxFilter } from '@hapvida/hapvida-core-components';

import newUseFilterParams from '@hapvida/hapvida-core-components/src/hooks/newUseFilterParams';

import { useAccessProfile } from 'components/filters/AccessProfileDrawerFilter/hooks/useAccessProfile';
import { mappedPartner } from 'components/filters/TypeOfPartnerCompaniesDrawerFilter/mappedPartnerCompanies';
import { mappedPlanType } from 'components/filters/PlanTypeDrawerFilter/components/mappedPlanTypes';
import {
  PartnerCompaniesContractStatusEnum,
  PartnerCompaniesTypeEnum,
} from '@constants';
import { PlanTypeEnum } from '@flows/private/partnerCompanies/pages/PartnerCompanyList/constants/contractTypeEnum';
import { mappedPartnerStatus } from 'components/filters/PartnerCompaniesStatusDrawerFilter/mappedPartnerCompaniesStatus';

import type {
  FiltersDrawerButtonProps,
  IFilterOptions,
  TFilterValue,
} from '../types';
import { FilterDrawerBase } from '../FilterDrawerBase';
import { formatObjectToFilterUrl } from '../FilterDrawerBase/utils/formatObjectToFilterUrl';

export function NewFilterDrawerPartnerCompany({
  subtitle,
  title,
  ...buttonProps
}: PropsWithChildren<FiltersDrawerButtonProps>) {
  const { changeMultiple } = newUseFilterParams({});
  const { accessProfileState } = useAccessProfile();

  const refs: IFilterOptions = {
    planType: useRef(null),
    statusType: useRef(null),
    contractType: useRef(null),
    profileId: useRef(null),
  };

  const handleApplyAll = () => {
    let inputsValueObj: TFilterValue = {};

    Object.keys(refs).forEach(key => {
      const ref = refs[key];

      if (ref?.current) {
        inputsValueObj = { ...inputsValueObj, ...ref.current?.filterValue };
      }
    });

    const objectFilterValues = { ...inputsValueObj };

    changeMultiple(formatObjectToFilterUrl(objectFilterValues));
  };

  const accessProfileFilters =
    accessProfileState?.data?.profiles.map(profile => ({
      content: <Typography variant="text">{profile.name}</Typography>,
      label: profile.name,
      value: profile.id,
    })) ?? [];

  const partnerList = Object.values(PartnerCompaniesTypeEnum);
  const typeOfPartnerCompaniesFilters = partnerList.map(mappedPartner);

  const partnerListStatus = Object.values(PartnerCompaniesContractStatusEnum);
  const partnerCompaniesStatusDrawerFilter =
    partnerListStatus.map(mappedPartnerStatus);

  const planTypeList = Object.values(PlanTypeEnum);
  const planTypeFilters = planTypeList.map(mappedPlanType);

  return (
    <FilterDrawerBase
      title={title}
      subtitle={subtitle}
      handleApplyAll={handleApplyAll}
      {...buttonProps}
    >
      <CheckboxFilter
        isMultiple={false}
        filters={accessProfileFilters}
        title="Perfis de acesso"
        name="profile-id"
        ref={refs.profileId}
      />

      <CheckboxFilter
        filters={partnerCompaniesStatusDrawerFilter}
        title="Status do contrato"
        name="status"
        ref={refs.statusType}
      />

      <CheckboxFilter
        filters={typeOfPartnerCompaniesFilters}
        title="Tipo de contrato"
        name="contract-type"
        ref={refs.contractType}
      />

      <CheckboxFilter
        filters={planTypeFilters}
        title="Tipo de plano"
        name="plan-type"
        ref={refs.planType}
      />
    </FilterDrawerBase>
  );
}
